export default {
  business: {
    eyebrow: 'Our Business',
    hero: {
      title: 'Connecting Japanese Chemicals to the World',
      description:
        "Connecting Japan's premium chemicals and minor metals with global markets through trusted partnerships, advanced logistics, and uncompromising quality standards.",
    },
    supply: {
      title: 'Products We Supply',
      description:
        'By pairing our wide network of Japanese manufacturers with our ability to provide timely solutions, we engage in the export and import of industrial chemicals, triangular trade and trade-related services.',
      moreInfo: 'We handle more than 500 chemicals.',
      cta: 'Are you interested in any Japanese Chemicals?',
      products: [
        // row 1
        'Fluorochemicals', 'Sputtering Target Raw Materials', 'Chemicals for Plating',
        // row 2
        'Silicones', 'Nanomaterials', 'Chemicals for Precious Metal Plating',
        // row 3
        'Plastic Raw Materials', 'Silane Coupling Agents', 'Pharmaceutical Intermediates', 'Anti Rusting Agent Raw Materials',
        // row 4
        'Monomers', 'Inorganic Pigments', 'Agrochemicals Intermediates', 'Water Treatment Chemicals',
        // row 5
        'Polyhydric Alcohol', 'Organic Pigments', 'Food Additives', 'Optical Glass Raw Materials',
        // row 6
        'Alcohol and Derivatives', 'Dye Intermediates', 'Cosmetic Raw Materials', 'Super Hard Tool Raw Materials',
        // row 7
        'Organic Acids', 'Carbon Raw Materials', 'Feed Additives', 'Special Alloy Raw Materials',
        // row 8
        'Petrochemical Products', 'Battery Raw Materials', 'Chelating Agents', 'Titanium Raw Materials',
        // row 9
        'Solvents', 'Ferrite Raw Materials', 'Paper Chemicals', 'Synthetic Rubber Additives',
        // row 10
        'Elastomers', 'Capacitor Raw Materials', 'Disinfectant Raw Materials', 'Abrasive Raw Materials',
        // row 11
        'Rubber Processing Chemicals', 'Chemicals for Solar Cell Production', 'Solder Raw Materials', 'Refractory Raw Materials',
        // row 12
        'Paint Additives', 'Chemicals for PDP Production', 'Ceramic Raw Materials', 'Mold Lubricant Raw Materials',
        // row 13
        'Adhesive Raw Materials', 'Chemicals for Printed Circuit Board Production', 'Soda Chemicals', 'Boiler Chemicals',
        // row 14
        'Polyurethane Raw Materials', 'Rechargeable Battery Raw Materials', 'Ammonia Chemicals', 'Fertilizer Raw Materials',
        // row 15
        'Flame Retardants', 'Fluorescent Substance Raw Materials', 'Various Inorganic Chemicals', 'Enzymes',
        // row 16
        'Polymerization Inhibitors', 'Chemicals for Semiconductor Production', 'Rare Metals and Compounds', 'Synthetic Perfume and Flavor Materials',
        // row 17
        'Surfactants', 'Encapsulant Raw Materials', 'Catalyst Raw Materials', 'Reagent Chemicals',
        // row 18
        'Ion Exchange Resin Raw Materials', 'Chemicals for Evaporation', 'Glass Raw Materials', 'We handle more than 500 chemicals.',
        // row 19 (col 4 empty)
        'Antifreezing Solution Raw Materials', 'Light Emitting Diode Raw Materials', 'Chemicals for Metal Surface Treatment',
      ],
    },
    manufacturers: {
      title: 'Manufacturing Partners',
      subtitle: '(in alphabetical order)',
      description:
        'Thanks to the long standing relationships we have established with manufacturers throughout Japan and our commitment to customized services, we continue to deliver Japanese chemicals and minor metals with optimal services and solutions to clients worldwide.',
      cta: 'Are you interested in any Japanese Chemicals?',
      list: [
        'ADEKA Corporation', 'Air Water Performance Chemical Inc.', 'AGC Seimi Chemical Co., Ltd.',
        'Amano Enzyme Inc.', 'Chiba Fine Chemical K.K.',
        'Daicel Corporation', 'Daicel FineChem Ltd.', 'Daihachi Chemical Industry Co., Ltd.',
        'Daiichi Kogyo Seiyaku Co., Ltd.', 'Dainichiseika Color & Chemicals Mfg. Co., Ltd.',
        'Daiso Co., Ltd.', 'Daiwa Fine Chemicals Co., Ltd.', 'DSS Corporation',
        'Ensho Sangyo Co., Ltd.', 'Fuji Chemical Industry Co., Ltd.', 'Fukuda Metal Foil & Powder Co., Ltd.',
        'Fuso Chemical Co., Ltd.', 'Goi Chemical Co., Ltd.', 'Harima Chemicals, Inc.',
        'Hayashi Pure Chemical Ind., Ltd.', 'Hokko Chemical Industry Co., Ltd.',
        'Hosoi Chemical Industry Co., Ltd.',
        'Iharanikkei Chemical Industry Co., Ltd.', 'Ikoma Fine Chemical Co., Ltd.',
        'Inoue Perfumery Mfg. Co., Ltd.', 'Inuisho Precious Metals Co., Ltd.',
        'Ise Chemicals Corporation', 'Ishihara Sangyo Kaisha, Ltd.', 'Itoh Oil Chemicals Co., Ltd.',
        'Iwata Chemical Co., Ltd.', 'JFE Mineral Company, Ltd.', 'JNC Corporation',
        'Johoku Chemical Co., Ltd.', 'Kansai Catalyst Co., Ltd.', 'Kanto Chemical Co., Inc.',
        'Kawaguchi Chemical Industry Co., Ltd.', 'Kinsei Matec Co., Ltd.', 'Kisan Kinzoku Chemicals Co., Ltd.',
        'Kishida Chemical Co., Ltd.', 'Koei Chemical Industry Co., Ltd.', 'Kojima Chemical Reagents, Inc.',
        'Kojundo Chemical Laboratory Co., Ltd.', 'Konan Muki Co., Ltd.', 'Konoshima Chemical Co., Ltd.',
        'Kureha Corporation', 'Maruzen Petrochemical Co., Ltd.', 'Matsugaki Chemical Industries Co., Ltd.',
        'Minalco Co Ltd.', 'Mitsubishi Gas Chemical Company, Inc.', 'Mitsubishi Materials Corporation',
        'Mitsubishi Chemical Corporation', 'Mitsuboshi Chemical Co., Ltd.', 'Mitsui Chemicals, Inc.',
        'Mitsui Fine Chemicals, Inc.', 'Mitsui Mining & Smelting Co., Ltd.',
        'Morita Chemical Industries Co., Ltd.', 'Musashino Chemical Laboratory, Ltd.',
        'Nagai Chemical Industrial Co., Ltd.', 'New Japan Chemical Co., Ltd.',
        'NI Chemitec Corporation', 'Nihon Kagaku Sangyo Co., Ltd.', 'Nikki Corporation',
        'Nikko Rica Corporation', 'Nippon Chemical Industrial Co., Ltd.', 'Nippon Denko Co., Ltd.',
        'Nippon Inorganic Colour & Chemical Co., Ltd.', 'Nippon Kasei Chemical Co., Ltd.',
        'Nippon Light Metal Co., Ltd.', 'Nippon Nyukazai Co., Ltd.',
        'Nippon Shokubai Co., Ltd.',
        'Nippon Steel Chemical & Material Co., Ltd.', 'Nippon Terpene Chemicals, Inc.',
        'Nippon Yttrium Co., Ltd.', 'Nissan Chemical Corporation',
        'Nitto Funka Trading Co., Ltd.', 'NOF Corporation',
        'Orient Chemical Industries Co., Ltd.', 'Osaka Titanium Technologies Co., Ltd.',
        'Ouchi Shinko Chemical Industrial Co., Ltd.', 'Rasa Industries, Ltd.',
        'Rin Kagaku Kyogo Co., Ltd.', 'Sanyo Chemical Industries, Ltd.',
        'Shikoku Chemicals Corporation', 'Shin\u2013Etsu Chemical Co., Ltd.',
        'Shinko Chemical Co., Ltd.', 'Showa Chemical Co., Ltd.',
        'Showa Chemical Industry Co., Ltd.', 'Showa Ether Co., Ltd.',
        'Showa Kako Corporation', 'Sumitomo Chemical Co., Ltd.',
        'Sumitomo Metal Mining Co., Ltd.', 'Taihei Chemical Industry Co., Ltd.',
        'Taiyo Chemical Industry Co., Ltd.',
        'Taki Chemical Co., Ltd.', 'Tama Chemicals Co., Ltd.', 'Tanabe Pharma Corporation',
        'Tannan Kagaku Kogyo Co., Ltd.', 'Tateho Chemical Industries Inc.',
        'Tayca Corporation', 'Terada Chemische Fabrik', 'The Honjo Chemical Corporation',
        'Tokuyama Corporation', 'Toagosei Co., Ltd.', 'Tomita Pharmaceutical Co., Ltd.',
        'Toray Fine Chemicals Co., Ltd.', 'TOSOH Corporation',
        'Toyobo Co., Ltd.', 'Toyo Gosei Co., Ltd.', 'Toyochem Co., Ltd.',
        'UBE Corporation', 'Ube Material Industries, Ltd.',
        'Ueno Fine Chemicals Industry Ltd.', 'Yakult Pharmaceutical Industry Co., Ltd.',
        'Yamato Metal Powder Co., Ltd.', 'Yasuhara Chemical Co., Ltd.',
        'Yodo Kagaku Co., Ltd.', 'Yoneyama Kagaku Kogyo Kaisha, Ltd.',
        'Yuki Gosei Kogyo Co., Ltd.',
      ],
    },
    distribution: {
      title: 'Global Logistics Network',
      description:
        'Our attentive service has resulted in a strong trust from our international client base, meaning we consistently deliver specialty chemicals worldwide.',
    },
    regions: [
      {
        title: 'Asia',
        countries:
          'Bangladesh, China, Hong Kong, India, Indonesia, Iran, South Korea, Kuwait, Malaysia, Nepal, Pakistan, Philippines, Saudi Arabia, Singapore, Sri Lanka, Taiwan, Thailand, Turkey, UAE, Uzbekistan, and Vietnam',
      },
      {
        title: 'Europe',
        countries: 'Austria, Belgium, France, Germany, Ireland, Italy, Netherlands, Spain, Sweden, Switzerland, Ukraine, and United Kingdom',
      },
      {
        title: 'Americas',
        countries: 'Argentina, Brazil, Canada, Mexico, Peru, and United States',
      },
      {
        title: 'Others',
        countries: 'Australia, Egypt, Mauritius, New Zealand, and South Africa',
      },
    ],
  },
};
